import type { Route } from 'workbox-routing';
import type { Strategy } from 'workbox-strategies';
import { IContainer, injectContainer } from '../../interface/container';

export interface IWorkboxUtils {
    findResponderStrategy: (urlFetch: string, event?: ExtendableEvent) => Strategy | null;
    routes: () => Array<Route>;
}

const TYPES = {
    IWorkboxUtils: Symbol.for('IWorkboxUtils'),
};

export function injectWorkboxUtils(container: IContainer = injectContainer()): IWorkboxUtils {
    return container.get<IWorkboxUtils>(TYPES.IWorkboxUtils);
}

export function bindWorkboxUtils(val: IWorkboxUtils, container: IContainer = injectContainer()) {
    return container.bind<IWorkboxUtils>(TYPES.IWorkboxUtils, val);
}

export function unbindWorkboxUtils(container: IContainer = injectContainer()) {
    return container.remove(TYPES.IWorkboxUtils);
}
